import { render } from "./StandartButton.vue?vue&type=template&id=56b65a8e&scoped=true"
import script from "./StandartButton.vue?vue&type=script&lang=js"
export * from "./StandartButton.vue?vue&type=script&lang=js"

import "./StandartButton.vue?vue&type=style&index=0&id=56b65a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b65a8e"]])

export default __exports__